import { FEATURE_POSSIBILITY_FAKE_GPS } from '../constant';
import { onRequest, onRequestForm } from '../utilities/Request';
import { COOKIES_CUSTOMER_ID, getCookies } from './Cookies';

// --- Haversine formula: hitung jarak antar dua koordinat (km)
const haversine = ([lat1, lon1], [lat2, lon2]) => {
    const toRad = deg => (deg * Math.PI) / 180;
    const R = 6371; // radius bumi (km)
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

// --- Ambil IP publik user
const getPublicIP = async () => {
    try {
        const res = await fetch("https://api.ipify.org?format=json");
        const data = await res.json();
        return data.ip;
    } catch (err) {
        console.error("❌ Error getting public IP:", err);
        return null;
    }
};

// --- Ambil Geolocation berdasarkan IP
const getGeoByIP = async (ip) => {
    try {
        const ip = await getPublicIP();
        const headers = { "Content-Type": "application/json" };
        if (ip) headers["x-forwarded-for"] = ip;

        const res = await fetch(
            `${process.env.REACT_APP_API_VICTORY}/geo-detect`,
            // "http://localhost:1995/victory/geo-detect",
            { method: "POST", headers }
        );
        const data = await res.json();
        // console.log("🌐 IP Geo:", JSON.stringify(data));

        if (data.code === 1 && data.result) {
            return data.result;
        } else {
            console.warn("⚠️ Failed to get IP geo:", data.message);
        }
    } catch (err) {
        console.error("❌ Error fetching IP geo:", err);
    }
}

const suspectionLog = async ( accuracy, currentLongitude, currentLaititude, activity_type ) => {
    const geoByIP = await getGeoByIP();
    if (!geoByIP) {
        console.warn("⚠️ Cannot perform fake GPS detection without IP geolocation.");
        return [];
    }
    // console.log("GET GEO BY IP ", geoByIP);

    const ipLatitude = parseFloat(geoByIP.latitude);
    const ipLongitude = parseFloat(geoByIP.longitude);

    const distance = haversine(
        [currentLaititude, currentLongitude],
        [ipLatitude, ipLongitude]
    );

    // console.log("DISTANCE ===> ", distance);
    // console.log("ACTIVITY TYPE ===> ", activity_type);

    // console.log(accuracy, currentLongitude, currentLaititude)
    
    const issues = [];

    // --- Cek akurasi GPS
    if (accuracy === 0 || accuracy < 3) {
        issues.push(`Akurasi GPS terlalu tinggi (kurang dari 3 meter) yaitu ${accuracy} meter`);
    } else if (accuracy > 1000) {
        issues.push(`Akurasi GPS terlalu rendah (lebih dari 1000 meter) yaitu ${accuracy} meter`);
    }

    // --- Cek jarak antara lokasi GPS dan IP
    if (distance > 50) {
        issues.push(`Jarak lokasi GPS dan IP lebih dari 50 km (${distance.toFixed(2)} km)`);
    }

    if (issues.length > 0) {
        const payload = {
            cust_no: getCookies(COOKIES_CUSTOMER_ID),
            activity_type,
            activity_description: FEATURE_POSSIBILITY_FAKE_GPS.get(activity_type),
            ip_address: geoByIP.ip,
            latitude: currentLaititude,
            longitude: currentLongitude,
            title_suspection: "FAKE GPS", // bisa fake gps, fraud, dll
            reason: JSON.stringify(issues),
            app_platform: "WEB",
            app_name: "VICTORY",
            provider_name: geoByIP.provider || "UNKNOWN",
        }

        logFakeGpsAttempt(payload)
    }
};

const logFakeGpsAttempt = (payload) => {
    try {
        let m_route = `/post/suspection-log`;
        // REQUEST
        onRequest(
            m_route,
            payload,
            (res_success) => {
                console.log("✅ Successfully logged fake GPS attempt:", res_success);
            },
            (res_fail) => {
                console.warn("Failed to log fake GPS attempt:", res_fail);
            }
        );
    } catch (err) {
        console.error("❌ Error logging fake GPS attempt:", err);
    }
}

export { getGeoByIP, suspectionLog, logFakeGpsAttempt };

